import { useTranslation } from "react-i18next";
import {
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarLeftExpand,
} from "react-icons/tb";

import { TriggerButton } from "./CustomTrigger.styles";

type TCustomTriggerProps = {
  collapsed: boolean;
  onCollapse: (collapsed: boolean) => void;
};

function CustomTrigger({ collapsed, onCollapse }: TCustomTriggerProps) {
  const { t } = useTranslation();

  const iconStyles = {
    strokeWidth: 1.5,
  };

  return (
    <TriggerButton onClick={() => onCollapse(!collapsed)}>
      {collapsed
        ? (
          <TbLayoutSidebarLeftExpand
            size={24}
            title={t("expand")}
            style={iconStyles}
          />
        )
        : (
          <TbLayoutSidebarLeftCollapse
            size={24}
            title={t("collapse")}
            style={iconStyles}
          />
        )}
    </TriggerButton>
  );
}

export default CustomTrigger;
